import { useEffect, useState } from "react";
import { User } from "lucide-react";
import { ImessageThemePreview, DiscordThemePreview } from "../app/helpers/ThemePreviews";
import { logout } from '../features/auth/authSlice'
import { getPushStatus } from '../app/push'
import { useDispatch, useSelector } from 'react-redux'
import { Bell, BellOff } from 'lucide-react'
import { parseUserInfo } from "../app/helpers/Utils";
import Button from "./Button";
import RenameModal from "./RenameModal";


const UserSettings = ( { open, user, selectedTheme, userDetails, onColorChanged, onUsernameChange }) => {
    const categories = ["Account","Themes", "Notifications", "LogOut"]
    const [selCategory, setSelCategory] = useState("Account");// Default selected Category
    const [selTheme, setSelTheme] = useState(localStorage.getItem('chatTheme')); // Default Theme Selected
    const themesArray = ["Discord", "iMessage"]; // List of themes
    const { userInfo, isAuthenticated } = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    const [pushMsg, setPushMsg] = useState('');
    const [userColor, setUserColor] = useState()
    const [showChangeNameModal, setShowChangeNameModal] = useState(false);
    const [username, setUsername] = useState(user)


    useEffect(() => {
        if(username){
            onUsernameChange(username)
        }
    }, [username])

    useEffect(() => {
        if(!userColor){
            setUserColor(parseUserInfo(username, userDetails))
        }
        if(userDetails && userColor){
            const user = userDetails.find((u) => u.username === username)
            if(user){
                user.color = userColor
            }
        }
    }, [userDetails, userColor])

    useEffect(() => {
        if (!open && userColor) {
            const user = userDetails.find((u) => u.username === username)
            if (user) {
                onColorChanged(user);
            }
            setShowChangeNameModal(false);
        }
    }, [open])

    const handleEnablePush = async () => {
        try {
          const { enablePushNotifications } = await import('../app/push');
          await enablePushNotifications();
          setPushMsg(<label className='flex'> <Bell color='#d4ff00' /> On </label>); /* '🔔 On' */
        } catch (e) {
          setPushMsg(e.message);
        }
      };

    const getThemePreview = () => {
        if (selTheme === "Discord")
            return <DiscordThemePreview />
        if (selTheme === "iMessage")
            return <ImessageThemePreview />
    }

    useEffect(() => {
        if(selTheme){
            // console.log("Found theme in storage:", selTheme)
            selectedTheme(selTheme)
            localStorage.setItem("chatTheme", selTheme)
        } else {
            // console.log("No theme in storage, defaulting to discord")
            selectedTheme("Discord")
            localStorage.setItem("chatTheme", "Discord")
        }
    }, [selTheme])

    useEffect(() => {
        let cancelled = false;
        getPushStatus().then((status) => {
          if (cancelled) return;
          setPushMsg(
            status === 'on'      ? <label className='flex'> <Bell color='#d4ff00' /> On </label> //'🔔 On'
            : status === 'blocked' ? '🔕 Blocked'
            : status === 'unsupported' ? ''
            : <label className='flex'> <BellOff /> Off </label> //'Enable notifications'
          );
        }).catch(() => {});
        return () => { cancelled = true; };
      }, []);
    




    return (
        <>
        {showChangeNameModal  ? <RenameModal username={username} onClose={() => setShowChangeNameModal(false)} onUsernameChange = {setUsername} /> : ''}
        {open && ( <div onClick={showChangeNameModal ? () => setShowChangeNameModal(false) : null}  className={`chat__settings ${open ? 'is-open' : ''} flex-col items-center md:items-start md:flex-row `}>
            <div className="flex flex-col items-center p-6 gap-4 mt-0 ">
                {/* Username */}
                <div className='flex w-min items-center gap-2'>
                    <span className='chat__avatar' style={{ background: userColor }}>
                        {username.charAt(0).toUpperCase()}
                    </span>
                    <span className='chat__me-name'>{username}</span>
                    <span className='chat__status-dot' title='Online' />
                </div>
                {/* Categories */}
                <div className="flex flex-row md:flex-col gap-2">
                    {categories.map((category,i) => (
                        <button 
                        type="button"
                        key={category} 
                        className={`settings__category  [@media(hover:hover)]:hover:bg-[var(--bg-hover)]  justify-center md:justify-start  text-xs md:text-lg   ${category === selCategory ? 'bg-[var(--button)]' : ''} ${category === "LogOut" ? "text-red-400" : ''}`} 
                        onClick={() => category === "LogOut" ? isAuthenticated ? dispatch(logout()) : "" : setSelCategory(category)} // Change our category on click
                        >
                            {category}
                        </button>
                    ))}
                </div>

            </div>
            {/* Settings Body */}
            {/* Accounts */}
            {selCategory === "Account" && (
                <div className="flex flex-col items-center md:items-stretch  w-full p-24 gap-4">
                    <div className="flex gap-4 justify-between items-center " >
                        <div className="flex flex-1 gap-4 justify-between" >
                            <label >Username</label> 
                            <label className="flex justify-end" >{username}</label>
                        </div>
                        
                        <Button text="Edit" onClick={() => setShowChangeNameModal(true)} />
                        {/* <label>{Object.entries(userInfo)}</label> */}
                        {/* <label for="picker">Choose a color:</label>
                        <input className="bg-transparent w-[250px]" type="color" id="picker" defaultChecked="hex" value="#3498db"></input>
                        <p>Selected Hex: <span id="hex-code">#3498db</span></p> */}
                    </div>
                    <div className="flex gap-4 justify-between items-center" >
                        <label >Icon Color</label> 
                        {/* <label>{Object.entries(userInfo)}</label> */}
                        {/* <label for="picker">Choose a color:</label> */}
                        <input className="bg-transparent w-[250px]" type="color" id="picker"  value={userColor} onChange={(event) => setUserColor(event.target.value)}></input>
                        {/* <p>Selected Hex: <span id="hex-code">#3498db</span></p> */}
                    </div>
                </div>
            )}

            {/* Themes */}
            {selCategory === "Themes" && (
                <div>
                    <div className="flex items-start md:mt-10 md:pl-24 gap-2">
                        {themesArray.map((theme) => (
                            <div 
                            key={theme} 
                            className= {`settings__category  [@media(hover:hover)]:hover:bg-[var(--bg-hover)] ${theme === selTheme ? 'bg-[var(--button)]' : ''}`} 
                            onClick={() => {setSelTheme(theme)}}
                            >
                                {theme}
                            </div>
                        ))}
                    </div>
                    <div className="flex md:pl-24 p-4">
                        {getThemePreview()}
                    </div>
                </div>
            )}

            {/* Notifications */}
            {selCategory === "Notifications" && (
                <div className="flex items-start md:mt-10 md:pl-24 gap-2">
                    <div className="settings__category  ">
                        Enable Notifications:
                    </div>
                    <button className={`settings__category  [@media(hover:hover)]:hover:bg-[var(--bg-hover)] `}
                    onClick={handleEnablePush}
                    >
                         {pushMsg || <label className='flex'> <BellOff /> Off </label>}  
                    </button>
              </div>
            )}
        </div>)}
        </>
    )

}


export default UserSettings;